'use strict';

var $pace = document.getElementById('pace');

var Pace = {
  open: function add() {
    $pace && $pace.classList.remove('is-hidden');
  },

  close: function close() {
    $pace && $pace.classList.add('is-hidden');
  }
};

$(document).on('pace:open', Pace.open);
$(document).on('pace:close', Pace.close);

module.exports = Pace;
